import { WORKBENCH_CUSTOM_ARGS } from '../../providers/param/registry-keys.js';
import { ParamRegistry } from '../../registries/param-registry.js';
import { PreHandlers } from '../../registries/pre-handler-registry.js';

/**
 * 获得 ActionPoint 自定义参数
 *
 * @public
 * @decorator
 */
function CustomArgs() {
    return ParamRegistry.decorate(WORKBENCH_CUSTOM_ARGS);
}
PreHandlers.set(WORKBENCH_CUSTOM_ARGS, ({ runner }) => runner.context.metadata);

export { CustomArgs };
//# sourceMappingURL=custom-args.js.map
